import { module } from 'angular';

import { CngBarChartDirective, default as cngBarChartDirectiveName } from './bar-chart-cng.directive';
import { default as defaultBarChartName, DefaultBarChart } from './bar-chart-default.component';

export default module('contact.commons.toolbox.bar-chart', [])
  .directive(cngBarChartDirectiveName, CngBarChartDirective)
  .component(defaultBarChartName, new DefaultBarChart()).name;
